<template>
  <div class="client-manager">
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="pagination"
             @change="handleTableChange"
             class="client-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <!-- 用户 -->
      <div class="avatar-36-con" slot="base_info" slot-scope="text">
        <img class="avatar" :src="text.avatar_url"/>
        <div class="nickname">{{text.nickname + (text.username ? '（' + text.username + '）' : '')}}</div>
        <a-icon v-if="text.sex === 1" type="man" style="color: #1890ff"></a-icon>
        <a-icon v-if="text.sex === 2" type="woman" style="color: #ff4d4f"></a-icon>
      </div>
      <!-- 地区 -->
      <div slot="location" slot-scope="text">
        {{text.province + (text.city ? ' ' + text.city : '')}}
      </div>
      <!-- phone -->
      <div slot="phone" slot-scope="text">
        {{ text ? text: '-' }}
      </div>
      <!-- bot_list -->
      <div slot="bot_list" slot-scope="text, record">
        <div class="avatar-36-con" v-for="bot in text" :key="bot.username">
          <img class="avatar" :src="bot.avatar_url"/>
          <div class="nickname">{{bot.nickname + (bot.username ? '（' + bot.username + '）' : '')}}</div>
        </div>
      </div>
      <!-- actions -->
      <div slot="actions" slot-scope="text, record">
        <a-dropdown >
          <a-menu slot="overlay" @click="handleMenuClick($event, record)">
            <a-menu-item key='refresh'>延长token过期时间</a-menu-item>
            <a-menu-item key='jump'>跳转到用户后台</a-menu-item>
          </a-menu>
          <a-button>
            操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </a-table>
  </div>
</template>

<script>
export default {
  name: 'MyClient',
  data () {
    return {
      getMyUsersUrl: global.DOMAIN + 'Umyusers/get_my_users',
      refreshTokenUrl: global.DOMAIN + 'umyusers/refresh_token',
      pagination: {
        showTotal: total => `共 ${total} 个客户`,
        pageSize: 10,
        current: 1
      },
      data: [],
      loading: false,
      columns: [{
        title: '基础信息',
        dataIndex: 'base_info',
        scopedSlots: { customRender: 'base_info' }
      }, {
        title: '地区',
        dataIndex: 'location',
        scopedSlots: { customRender: 'location' }
      }, {
        title: '手机号',
        dataIndex: 'phone',
        scopedSlots: { customRender: 'phone' }
      }, {
        title: '机器人',
        dataIndex: 'bot_list',
        scopedSlots: { customRender: 'bot_list' },
        filters: []
      }, {
        title: '已用/可用群',
        dataIndex: 'chatroom_num',
        align: 'center',
        width: '150px',
        scopedSlots: { customRender: 'chatroom_num' }
      }, {
        title: '紫豆余额',
        dataIndex: 'balance'
      }, {
        title: '注册时间',
        dataIndex: 'create_time'
      }, {
        title: '操作',
        dataIndex: 'actions',
        scopedSlots: { customRender: 'actions' }
      }]
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    handleTableChange (pagination) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.fetch()
    },
    fetch () {
      console.log('params:', this.params)
      this.loading = true
      this.axios.post(this.getMyUsersUrl, {
        token: sessionStorage.token
      }).then((data) => {
        if (data.data.err_code === 0) {
          const pagination = { ...this.pagination }
          pagination.total = data.data.content.total_count
          let clientList = data.data.content.client_list
          let dataList = []
          clientList.forEach((item) => {
            let baseInfo = {
              sex: item.sex,
              avatar_url: item.avatar_url,
              nickname: item.nickname || '',
              username: item.username
            }
            let location = {
              country: item.country || '',
              city: item.city || '',
              province: item.province || ''
            }
            let chatroomNum = {
              chatroom_used: item.chatroom_used,
              chatroom_count: item.chatroom_count
            }
            let createTime = item.create_time
            dataList.push({
              base_info: baseInfo,
              location: location,
              chatroom_num: chatroomNum,
              ...item,
              create_time: this.transform(createTime, 'yyyy-MM-dd hh:mm:ss')
            })
          })
          this.loading = false
          this.data = dataList
          this.pagination = pagination
        } else if (data.data.err_code === 50002) {
          console.log('token 不对，跳转登录')
          this.$router.push('/')
        }
      })
    },
    transform (value, fmt, ...args) {
      if (typeof value === 'number') {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11) value *= 1000

        let date = new Date(value)
        var o = {
          'M+': date.getMonth() + 1, // 月份
          'd+': date.getDate(), // 日
          'h+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds(), // 秒
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay()
        }
        var weekMap = [
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ]
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length)
          )
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt) && k !== 'W') {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length)
            )
          }
          if (new RegExp('(' + k + ')').test(fmt) && k === 'W') {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]])
          }
        }
        return fmt
      } else return ''
    },
    handleMenuClick (e, record) {
      let action = e.key
      if (action === 'jump') {
        var url = process.env.VUE_APP_TO_ZIDOU_URL
        url += 'features?token=' + record.token
        window.open(url)
      } else if (action === 'refresh') {
        this.axios.post(this.refreshTokenUrl, {
          token: sessionStorage.token,
          client_id: record.client_id
        }).then(res => {
          if (res.data.err_code === 0) {
            this.$message.success('操作成功')
          } else {
            this.$message.error('操作失败')
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
